import type { Widget } from "@/types";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getWidgets = async (
  token: string,
  baseUrl: string,
  projectId: string,
  params?: object,
  config?: object
): Promise<{ widgets: Array<Widget>; meta: { count: number } }> => {
  const queryPath = `${baseUrl}/projects/${projectId}/widgets`;

  const res = await getData(token, queryPath, params, config);
  const widgets = (await deserialize(res.data)) as Array<Widget>;

  return {
    widgets,
    meta: res.data?.meta ?? { count: widgets.length }
  };
};
